import React from "react";

import LOTTIE_ITEM_NOT_FOUND from "../assets/item_not_found.json";
import Lottie from "lottie-react";
import { Grid } from "@mui/material";

const ItemNotFound = () => {

  // Override parent grid components size.
  const containerStyles = {
    width: "200vh", 
    height: "50vh", 
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Grid item sx={containerStyles} >
        <Lottie animationData={LOTTIE_ITEM_NOT_FOUND} style={{ width: "80%", height: "80%" }} />
    </Grid>
  );
};

export default ItemNotFound;
